import {useState, useEffect} from "react"
import {useAppDispatch, useAppSelector} from "@/store/hooks"
import {selectAuth} from "@/store/auth/authSelectors"
import {updateLoginSectionSaga} from "@/store/auth/authSlice"
import type {LoginSection} from "@/store/auth/authSlice"
import AccountSettingsTitle from "@/components/modals/AccountSettingsModal/components/AccountSettingsTitle/AccountSettingsTitle"
import FormColumn from "@/components/ui/Form/components/FormColumn/FormColumn"
import FormTitle from "@/components/ui/Form/components/FormTitle/FormTitle"
import FormDivider from "@/components/ui/Form/components/FormDivider/FormDivider"
import {showToast} from "@/components/app/Toast/showToast"
import FormLabel from "@/components/ui/Form/components/FormLabel/FormLabel"
import Select from "@/components/ui/Select/Select"

const LOGIN_SECTION_OPTIONS = [
    {value: 'my-tasks', label: 'My tasks'},
    {value: 'team', label: 'Team'},
    {value: 'projects', label: 'Projects'},
    {value: 'all-tasks', label: 'All tasks'},
]

const AccountSettingsModalPreferences = () => {
    const dispatch = useAppDispatch()
    const auth = useAppSelector(selectAuth)
    const [loginSection, setLoginSection] = useState<LoginSection>(auth?.loginSection || 'projects')

    useEffect(() => {
        setLoginSection(auth?.loginSection || 'projects')
    }, [auth?.loginSection])

    const handleLoginSectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value as LoginSection
        setLoginSection(value)
        dispatch(updateLoginSectionSaga(value))
        showToast('Preferences saved')
    }

    return (
        <>
            <AccountSettingsTitle>Preferences</AccountSettingsTitle>
            <FormDivider />
            <FormColumn gap={16}>
                <FormTitle>General</FormTitle>
                <FormColumn>
                    <FormLabel>Open on login</FormLabel>
                    <Select
                        value={loginSection}
                        onChange={handleLoginSectionChange}
                        options={LOGIN_SECTION_OPTIONS}
                    />
                </FormColumn>
            </FormColumn>
        </>
    )
}

export default AccountSettingsModalPreferences
